import React, { useState } from "react";
import PickingListDetaildata from "./Table/PickingListDetaildata";
import { Map, Draggable, Marker } from "pigeon-maps";

import "tw-elements";
export default function PicklistDetails() {
  const [showModaldetail, setShowModaldetail] = useState(false);
  const Location = [{ lat: 21.03739, lng: 105.77504 }];
  return (
    <div className="flex flex-col container max-w-4xl mt-2 mb-5 xl:max-w-7xl">
      <div className="flex mt-10">
        <p className="text-gray-700 text-lg font-semibold">
          The Name of the Schedule
        </p>
      </div>
      <div className="flex flex-wrap bg-white border-2 pl-3 mt-10 shadow-md w-fit w-max rounded-xl">
        <div className="flex flex-wrap float-left ">
          <div className=" text-gray-900 py-4 font-medium ">
            {" "}
            <svg
              width="22"
              height="19"
              viewBox="0 0 22 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.8122 6.30951H0.90932C0.635938 6.30951 0.414062 6.1333 0.414062 5.91619V3.84382C0.414062 2.78836 1.49521 1.92975 2.82423 1.92975H18.8973C20.2261 1.92975 21.3072 2.78836 21.3072 3.84382V5.91639C21.3075 6.1335 21.0856 6.30951 20.8122 6.30951ZM1.40458 5.52288H20.317V3.84362C20.317 3.22199 19.6803 2.71618 18.8976 2.71618H2.82423C2.04123 2.71618 1.40458 3.22199 1.40458 3.84362V5.52288Z"
                fill="#1F78B4"
              />
              <path
                d="M10.3977 18.3441H2.82423C1.49521 18.3441 0.414062 17.4854 0.414062 16.43V5.91383C0.414062 5.69671 0.635938 5.52051 0.90932 5.52051H20.8122C21.0856 5.52051 21.3075 5.69671 21.3075 5.91383V9.67985C21.3075 9.89696 21.0856 10.0732 20.8122 10.0732C20.5389 10.0732 20.317 9.89696 20.317 9.67985V6.30714H1.40458V16.4298C1.40458 17.0514 2.04148 17.5572 2.82423 17.5572H10.3977C10.6711 17.5572 10.893 17.7334 10.893 17.9505C10.893 18.1677 10.6713 18.3441 10.3977 18.3441Z"
                fill="#1F78B4"
              />
              <path
                d="M4.87805 3.99841C4.60468 3.99841 4.38281 3.82221 4.38281 3.6051V1.03968C4.38281 0.822569 4.60468 0.646362 4.87805 0.646362C5.15142 0.646362 5.37329 0.822569 5.37329 1.03968V3.6051C5.37329 3.82221 5.15167 3.99841 4.87805 3.99841Z"
                fill="#1F78B4"
              />
              <path
                d="M16.839 3.99841C16.5656 3.99841 16.3438 3.82221 16.3438 3.6051V1.03968C16.3438 0.822569 16.5656 0.646362 16.839 0.646362C17.1124 0.646362 17.3342 0.822569 17.3342 1.03968V3.6051C17.3342 3.82221 17.1124 3.99841 16.839 3.99841Z"
                fill="#1F78B4"
              />
              <path
                d="M10.8624 3.99841C10.5891 3.99841 10.3672 3.82221 10.3672 3.6051V1.03968C10.3672 0.822569 10.5891 0.646362 10.8624 0.646362C11.1358 0.646362 11.3577 0.822569 11.3577 1.03968V3.6051C11.3577 3.82221 11.1358 3.99841 10.8624 3.99841Z"
                fill="#1F78B4"
              />
              <path
                d="M4.87093 8.90326H4.49479C4.32518 8.90326 4.1875 8.79411 4.1875 8.6592V8.36046C4.1875 8.22574 4.32493 8.11639 4.49479 8.11639H4.87093C5.04055 8.11639 5.17822 8.22554 5.17822 8.36046V8.6592C5.17822 8.79411 5.04079 8.90326 4.87093 8.90326Z"
                fill="#1F78B4"
              />
              <path
                d="M8.98812 8.90326H8.61198C8.44236 8.90326 8.30469 8.79411 8.30469 8.6592V8.36046C8.30469 8.22574 8.44212 8.11639 8.61198 8.11639H8.98812C9.15773 8.11639 9.29541 8.22554 9.29541 8.36046V8.6592C9.29541 8.79411 9.15798 8.90326 8.98812 8.90326Z"
                fill="#1F78B4"
              />
              <path
                d="M13.1053 8.90326H12.7292C12.5596 8.90326 12.4219 8.79411 12.4219 8.6592V8.36046C12.4219 8.22574 12.5593 8.11639 12.7292 8.11639H13.1053C13.2749 8.11639 13.4126 8.22554 13.4126 8.36046V8.6592C13.4126 8.79411 13.2752 8.90326 13.1053 8.90326Z"
                fill="#1F78B4"
              />
              <path
                d="M17.2225 8.90326H16.8464C16.6767 8.90326 16.5391 8.79411 16.5391 8.6592V8.36046C16.5391 8.22574 16.6765 8.11639 16.8464 8.11639H17.2225C17.3921 8.11639 17.5298 8.22554 17.5298 8.36046V8.6592C17.5295 8.79411 17.3921 8.90326 17.2225 8.90326Z"
                fill="#1F78B4"
              />
              <path
                d="M4.87093 12.1732H4.49479C4.32518 12.1732 4.1875 12.064 4.1875 11.9291V11.6304C4.1875 11.4957 4.32493 11.3864 4.49479 11.3864H4.87093C5.04055 11.3864 5.17822 11.4955 5.17822 11.6304V11.9291C5.17822 12.064 5.04079 12.1732 4.87093 12.1732Z"
                fill="#1F78B4"
              />
              <path
                d="M8.98812 12.1732H8.61198C8.44236 12.1732 8.30469 12.064 8.30469 11.9291V11.6304C8.30469 11.4957 8.44212 11.3864 8.61198 11.3864H8.98812C9.15773 11.3864 9.29541 11.4955 9.29541 11.6304V11.9291C9.29541 12.064 9.15798 12.1732 8.98812 12.1732Z"
                fill="#1F78B4"
              />
              <path
                d="M4.87093 15.4464H4.49479C4.32518 15.4464 4.1875 15.3373 4.1875 15.2023V14.9036C4.1875 14.7689 4.32493 14.6595 4.49479 14.6595H4.87093C5.04055 14.6595 5.17822 14.7687 5.17822 14.9036V15.2023C5.17822 15.3373 5.04079 15.4464 4.87093 15.4464Z"
                fill="#1F78B4"
              />
              <path
                d="M8.98812 15.4464H8.61198C8.44236 15.4464 8.30469 15.3373 8.30469 15.2023V14.9036C8.30469 14.7689 8.44212 14.6595 8.61198 14.6595H8.98812C9.15773 14.6595 9.29541 14.7687 9.29541 14.9036V15.2023C9.29541 15.3373 9.15798 15.4464 8.98812 15.4464Z"
                fill="#1F78B4"
              />
              <path
                d="M16.2512 18.3475C13.4633 18.3475 11.1953 16.5463 11.1953 14.3323C11.1953 12.1181 13.4633 10.3169 16.2512 10.3169C19.039 10.3169 21.307 12.1181 21.307 14.3323C21.307 16.5463 19.0387 18.3475 16.2512 18.3475ZM16.2512 11.1035C14.0094 11.1035 12.1858 12.5519 12.1858 14.3323C12.1858 16.1126 14.0094 17.5608 16.2512 17.5608C18.4929 17.5608 20.3165 16.1126 20.3165 14.3323C20.3165 12.5519 18.4927 11.1035 16.2512 11.1035Z"
                fill="#1F78B4"
              />
              <path
                d="M15.7338 15.7985C15.7298 15.7985 15.7258 15.7985 15.7219 15.7983C15.5825 15.7957 15.4507 15.7463 15.3594 15.6628L14.3084 14.6999C14.1294 14.5359 14.1517 14.2874 14.3585 14.1452C14.565 14.0032 14.8782 14.0203 15.057 14.1849L15.7514 14.8211L17.72 13.1837C17.9087 13.0262 18.2224 13.0209 18.42 13.1709C18.6179 13.321 18.6251 13.5698 18.4361 13.7269L16.0916 15.6769C15.9982 15.7546 15.869 15.7985 15.7338 15.7985Z"
                fill="#1F78B4"
              />
            </svg>
          </div>
          <div className="mt-3 mr-8 ml-2 text-gray-700 font-medium">
            21-oct-2021
          </div>
        </div>
        <div className="flex flex-wrap float-left ">
          <div className=" text-gray-900 py-4 font-medium ">
            {" "}
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                fill="#1F78B4"
              />
            </svg>
          </div>
          <div className="mt-3  ml-2 text-gray-700 font-medium">02:45PM</div>
        </div>
        <div className="flex">
          <div class=" inline-flex w-16 mt-6 ml-4 mr-4 bg-blue-200 rounded-full h-0.5 "></div>
        </div>
        <div className="flex flex-wrap float-left ">
          <div className=" text-gray-900 py-4 font-medium ">
            {" "}
            <svg
              width="22"
              height="19"
              viewBox="0 0 22 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.8122 6.30951H0.90932C0.635938 6.30951 0.414062 6.1333 0.414062 5.91619V3.84382C0.414062 2.78836 1.49521 1.92975 2.82423 1.92975H18.8973C20.2261 1.92975 21.3072 2.78836 21.3072 3.84382V5.91639C21.3075 6.1335 21.0856 6.30951 20.8122 6.30951ZM1.40458 5.52288H20.317V3.84362C20.317 3.22199 19.6803 2.71618 18.8976 2.71618H2.82423C2.04123 2.71618 1.40458 3.22199 1.40458 3.84362V5.52288Z"
                fill="#1F78B4"
              />
              <path
                d="M10.3977 18.3441H2.82423C1.49521 18.3441 0.414062 17.4854 0.414062 16.43V5.91383C0.414062 5.69671 0.635938 5.52051 0.90932 5.52051H20.8122C21.0856 5.52051 21.3075 5.69671 21.3075 5.91383V9.67985C21.3075 9.89696 21.0856 10.0732 20.8122 10.0732C20.5389 10.0732 20.317 9.89696 20.317 9.67985V6.30714H1.40458V16.4298C1.40458 17.0514 2.04148 17.5572 2.82423 17.5572H10.3977C10.6711 17.5572 10.893 17.7334 10.893 17.9505C10.893 18.1677 10.6713 18.3441 10.3977 18.3441Z"
                fill="#1F78B4"
              />
              <path
                d="M4.87805 3.99841C4.60468 3.99841 4.38281 3.82221 4.38281 3.6051V1.03968C4.38281 0.822569 4.60468 0.646362 4.87805 0.646362C5.15142 0.646362 5.37329 0.822569 5.37329 1.03968V3.6051C5.37329 3.82221 5.15167 3.99841 4.87805 3.99841Z"
                fill="#1F78B4"
              />
              <path
                d="M16.839 3.99841C16.5656 3.99841 16.3438 3.82221 16.3438 3.6051V1.03968C16.3438 0.822569 16.5656 0.646362 16.839 0.646362C17.1124 0.646362 17.3342 0.822569 17.3342 1.03968V3.6051C17.3342 3.82221 17.1124 3.99841 16.839 3.99841Z"
                fill="#1F78B4"
              />
              <path
                d="M10.8624 3.99841C10.5891 3.99841 10.3672 3.82221 10.3672 3.6051V1.03968C10.3672 0.822569 10.5891 0.646362 10.8624 0.646362C11.1358 0.646362 11.3577 0.822569 11.3577 1.03968V3.6051C11.3577 3.82221 11.1358 3.99841 10.8624 3.99841Z"
                fill="#1F78B4"
              />
              <path
                d="M4.87093 8.90326H4.49479C4.32518 8.90326 4.1875 8.79411 4.1875 8.6592V8.36046C4.1875 8.22574 4.32493 8.11639 4.49479 8.11639H4.87093C5.04055 8.11639 5.17822 8.22554 5.17822 8.36046V8.6592C5.17822 8.79411 5.04079 8.90326 4.87093 8.90326Z"
                fill="#1F78B4"
              />
              <path
                d="M8.98812 8.90326H8.61198C8.44236 8.90326 8.30469 8.79411 8.30469 8.6592V8.36046C8.30469 8.22574 8.44212 8.11639 8.61198 8.11639H8.98812C9.15773 8.11639 9.29541 8.22554 9.29541 8.36046V8.6592C9.29541 8.79411 9.15798 8.90326 8.98812 8.90326Z"
                fill="#1F78B4"
              />
              <path
                d="M13.1053 8.90326H12.7292C12.5596 8.90326 12.4219 8.79411 12.4219 8.6592V8.36046C12.4219 8.22574 12.5593 8.11639 12.7292 8.11639H13.1053C13.2749 8.11639 13.4126 8.22554 13.4126 8.36046V8.6592C13.4126 8.79411 13.2752 8.90326 13.1053 8.90326Z"
                fill="#1F78B4"
              />
              <path
                d="M17.2225 8.90326H16.8464C16.6767 8.90326 16.5391 8.79411 16.5391 8.6592V8.36046C16.5391 8.22574 16.6765 8.11639 16.8464 8.11639H17.2225C17.3921 8.11639 17.5298 8.22554 17.5298 8.36046V8.6592C17.5295 8.79411 17.3921 8.90326 17.2225 8.90326Z"
                fill="#1F78B4"
              />
              <path
                d="M4.87093 12.1732H4.49479C4.32518 12.1732 4.1875 12.064 4.1875 11.9291V11.6304C4.1875 11.4957 4.32493 11.3864 4.49479 11.3864H4.87093C5.04055 11.3864 5.17822 11.4955 5.17822 11.6304V11.9291C5.17822 12.064 5.04079 12.1732 4.87093 12.1732Z"
                fill="#1F78B4"
              />
              <path
                d="M8.98812 12.1732H8.61198C8.44236 12.1732 8.30469 12.064 8.30469 11.9291V11.6304C8.30469 11.4957 8.44212 11.3864 8.61198 11.3864H8.98812C9.15773 11.3864 9.29541 11.4955 9.29541 11.6304V11.9291C9.29541 12.064 9.15798 12.1732 8.98812 12.1732Z"
                fill="#1F78B4"
              />
              <path
                d="M4.87093 15.4464H4.49479C4.32518 15.4464 4.1875 15.3373 4.1875 15.2023V14.9036C4.1875 14.7689 4.32493 14.6595 4.49479 14.6595H4.87093C5.04055 14.6595 5.17822 14.7687 5.17822 14.9036V15.2023C5.17822 15.3373 5.04079 15.4464 4.87093 15.4464Z"
                fill="#1F78B4"
              />
              <path
                d="M8.98812 15.4464H8.61198C8.44236 15.4464 8.30469 15.3373 8.30469 15.2023V14.9036C8.30469 14.7689 8.44212 14.6595 8.61198 14.6595H8.98812C9.15773 14.6595 9.29541 14.7687 9.29541 14.9036V15.2023C9.29541 15.3373 9.15798 15.4464 8.98812 15.4464Z"
                fill="#1F78B4"
              />
              <path
                d="M16.2512 18.3475C13.4633 18.3475 11.1953 16.5463 11.1953 14.3323C11.1953 12.1181 13.4633 10.3169 16.2512 10.3169C19.039 10.3169 21.307 12.1181 21.307 14.3323C21.307 16.5463 19.0387 18.3475 16.2512 18.3475ZM16.2512 11.1035C14.0094 11.1035 12.1858 12.5519 12.1858 14.3323C12.1858 16.1126 14.0094 17.5608 16.2512 17.5608C18.4929 17.5608 20.3165 16.1126 20.3165 14.3323C20.3165 12.5519 18.4927 11.1035 16.2512 11.1035Z"
                fill="#1F78B4"
              />
              <path
                d="M15.7338 15.7985C15.7298 15.7985 15.7258 15.7985 15.7219 15.7983C15.5825 15.7957 15.4507 15.7463 15.3594 15.6628L14.3084 14.6999C14.1294 14.5359 14.1517 14.2874 14.3585 14.1452C14.565 14.0032 14.8782 14.0203 15.057 14.1849L15.7514 14.8211L17.72 13.1837C17.9087 13.0262 18.2224 13.0209 18.42 13.1709C18.6179 13.321 18.6251 13.5698 18.4361 13.7269L16.0916 15.6769C15.9982 15.7546 15.869 15.7985 15.7338 15.7985Z"
                fill="#1F78B4"
              />
            </svg>
          </div>
          <div className="mt-3 mr-8 ml-2 text-gray-700 font-medium">
            21-oct-2021
          </div>
        </div>
        <div className="flex flex-wrap float-left ">
          <div className=" text-gray-900 py-4 font-medium ">
            {" "}
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                fill="#1F78B4"
              />
            </svg>
          </div>
          <div className="mt-3 mr-8 ml-2 text-gray-700 font-medium">
            09:30am
          </div>
        </div>
      </div>
      <div className="flex flex-wrap   pl-3 mt-10  rounded-xl">
        <div className="flex flex-wrap float-left ">
          <div className=" text-gray-400 py-4 font-medium "> Customer:</div>
          <div className="mt-4 mr-8 ml-2 text-gray-700 font-medium">
            Customer Name
          </div>
        </div>
        <div className="flex flex-wrap float-left lg:ml-14 md:ml-auto sm:ml-auto">
          <div className=" text-gray-900 py-4 font-medium ">
            {" "}
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12.5"
                cy="12.5"
                r="6.5"
                stroke="#1F78B4"
                stroke-width="2"
              />
              <path d="M12.5 5V0" stroke="#1F78B4" stroke-width="2" />
              <path d="M12.5 25V20" stroke="#1F78B4" stroke-width="2" />
              <path d="M25 12.5L19 12.5" stroke="#1F78B4" stroke-width="2" />
              <path d="M6 12.5L0 12.5" stroke="#1F78B4" stroke-width="2" />
              <circle
                cx="12.5"
                cy="12.5"
                r="3"
                fill="#1F78B4"
                stroke="#1F78B4"
              />
            </svg>
          </div>
          <div className="mt-4  sm:ml-4   text-gray-700 font-medium">
            Kuldeep Nagar, Nanhera, Ambala Cantt, Haryana 133004, India
          </div>
        </div>
      </div>
      <div className="flex flex-wrap   pl-3 mt-10  rounded-xl">
        <div className="flex flex-wrap float-left ">
          <div className=" text-gray-400 py-4 font-medium "> ID:</div>
          <div className="mt-4 mr-8 ml-2 text-gray-700 font-medium">123456</div>
        </div>
        <div className="flex flex-wrap float-left lg:ml-16 ">
          <div className=" text-gray-900 py-4 font-medium ">
            {" "}
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5 0C5.59687 0 0 5.59687 0 12.5C0 19.4031 5.59687 25 12.5 25C19.4031 25 25 19.4031 25 12.5C25 5.59687 19.4031 0 12.5 0ZM13.5417 16.726V13.5417H16.6604C16.599 14.7323 16.4396 15.875 16.1854 16.9573C15.3281 16.8323 14.4417 16.7615 13.5417 16.726ZM15.5802 18.9781C15.0604 20.3635 14.3729 21.5792 13.5417 22.5781V18.8073C14.2354 18.8365 14.9156 18.8917 15.5802 18.9781ZM13.5417 11.4583V8.31771C14.4458 8.28229 15.3344 8.21042 16.1958 8.08437C16.4438 9.15417 16.601 10.2833 16.6604 11.4583H13.5417ZM13.5417 6.23542V2.42188C14.3812 3.43125 15.074 4.66146 15.5948 6.06354C14.926 6.15104 14.2406 6.20625 13.5417 6.23542ZM16.3573 2.83229C17.6458 3.34896 18.8094 4.11146 19.7844 5.06771C19.1156 5.31146 18.4188 5.52812 17.6812 5.7C17.3229 4.66667 16.874 3.71042 16.3573 2.83229ZM8.81458 16.9573C8.56042 15.875 8.4 14.7323 8.33958 13.5417H11.4583V16.726C10.5573 16.7615 9.67292 16.8323 8.81458 16.9573ZM11.4583 18.8073V22.5781C10.6271 21.5792 9.93958 20.3635 9.41979 18.9781C10.0844 18.8917 10.7646 18.8365 11.4583 18.8073ZM8.33958 11.4583C8.39896 10.2833 8.55521 9.15417 8.80417 8.08437C9.66562 8.21042 10.5542 8.28229 11.4583 8.31771V11.4583H8.33958ZM9.40625 6.06354C9.92708 4.66146 10.6198 3.43125 11.4583 2.42188V6.23542C10.7594 6.20625 10.074 6.15104 9.40625 6.06354ZM7.31771 5.69896C6.58021 5.52708 5.88333 5.31042 5.21562 5.06667C6.19167 4.11042 7.35417 3.34792 8.64271 2.83125C8.12604 3.71042 7.67708 4.66667 7.31771 5.69896ZM6.74583 7.69687C6.47083 8.89583 6.29375 10.1552 6.23333 11.4583H2.13646C2.30833 9.73125 2.90625 8.12812 3.82083 6.75208C4.7375 7.12812 5.7125 7.45 6.74583 7.69687ZM6.75521 17.3448C5.72604 17.5906 4.75521 17.9094 3.84167 18.2823C2.91458 16.899 2.30938 15.2833 2.13646 13.5417H6.23438C6.29479 14.8594 6.475 16.1333 6.75521 17.3448ZM7.33125 19.3417C7.6875 20.3583 8.13125 21.301 8.64062 22.1667C7.36667 21.6562 6.21771 20.9052 5.24896 19.9635C5.91146 19.725 6.60208 19.5104 7.33125 19.3417ZM17.6687 19.3417C18.3979 19.5115 19.0875 19.724 19.751 19.9635C18.7812 20.9042 17.6323 21.6562 16.3583 22.1677C16.8677 21.301 17.3115 20.3583 17.6687 19.3417ZM18.2448 17.3448C18.526 16.1333 18.7052 14.8594 18.7667 13.5417H22.8646C22.6906 15.2833 22.0854 16.899 21.1583 18.2823C20.2448 17.9094 19.2729 17.5906 18.2448 17.3448ZM18.7667 11.4583C18.7062 10.1552 18.5281 8.89583 18.2542 7.69687C19.2875 7.45 20.2635 7.12812 21.1802 6.75208C22.0938 8.12812 22.6917 9.73125 22.8635 11.4583H18.7667Z"
                fill="#1F78B4"
              />
            </svg>
          </div>
          <div className="mt-4  sm:ml-4  text-gray-700 font-medium">
            <a href="https://www.wbsite.com">www.wbsite.com</a>
          </div>
        </div>
      </div>
      <div class="accordion-item bg-transparent ">
        <h2 class="accordion-header mb-0" id="headingOne">
          <button
            class="
          relative
          flex
          items-center
          w-full
          py-4
          px-5
          text-base text-blue-900 text-left
          bg-white
          border-0
          rounded-none
          transition
          focus:outline-none
        "
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <svg
              className="mr-2 hover:rotate-180"
              width="15"
              height="10"
              viewBox="0 0 15 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.6582 1.07812L7.50031 7.57812L1.00031 1.07813"
                stroke="#1F78B4"
                stroke-width="2"
              />
            </svg>{" "}
            Notes
          </button>
        </h2>
        <div
          id="collapseOne"
          class="accordion-collapse collapse show"
          aria-labelledby="headingOne"
          data-bs-parent="#accordionExample"
        >
          <div class="accordion-body py-4 px-5">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum
          </div>
        </div>
      </div>
      <h2 class="accordion-header mb-0" id="headingOne">
        <div
          class="
      relative
      flex
      items-center
      w-full
      py-4
      px-5
      text-base text-blue-900 text-left
      bg-transparent
      border-0
      rounded-none
      transition
      focus:outline-none
    "
        >
          <svg
            className="mr-2 hover:rotate-180"
            width="15"
            height="10"
            viewBox="0 0 15 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.6582 1.07812L7.50031 7.57812L1.00031 1.07813"
              stroke="#1F78B4"
              stroke-width="2"
            />
          </svg>{" "}
          Picking List
        </div>
      </h2>
      <div class="flex flex-wrap ">
          <div
            className="tabelcontainer -ml-6  mx-4"
            // "w-[calc(100vw_-_12rem)]"
          >
            <PickingListDetaildata />
          </div>
      </div>
      <div className="flex p-6  ">
        <div className="float-left">
          <button
            className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="button"
          >
            Cancel
          </button>
        </div>

        <div className="float-right ml-auto">
          <button
            className="bg-green-500  text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="button"
            onClick={() => setShowModaldetail(true)}
          >
            Finish Pick
          </button>
          {showModaldetail ? (
            <>
              <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative  my-auto mx-auto lg:max-w-xl md:max-w-lg">
                  {/*content*/}
                  <div className="border-0  p-5 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between mt-2 ml-2  rounded-t">
                      <div>
                        <h2 className="font-Montserrat text-xl font-bold text-black">
                          Scanning Items to Pick
                        </h2>
                        <div className="border-b-2 border-blue-200 w-20"></div>
                      </div>
                      <button
                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => setShowModaldetail(false)}
                      >
                        <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                          ×
                        </span>
                      </button>
                    </div>

                    <form>
                      <div class="flex relative z-0 w-full  group">
                        <h2 className="ml-2 mt-6 text-sm text-blue-200">
                          Item:
                        </h2>
                        <input
                          type="text"
                          name="Allocated"
                          class="block py-2.5 ml-5 px-0 w-1/2 text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                          placeholder=" "
                        />
                      </div>

                      <div class="flex relative z-0 w-full  group">
                        <h2 className="ml-2 mt-6 text-sm text-blue-200">
                          Type:
                        </h2>
                        <input
                          type="text"
                          name="item_name"
                          class="block py-2.5 ml-5 mr-8 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                          placeholder=" "
                        />

                        <h2 className="ml-2 mt-6 text-sm text-blue-200">
                          Allocated:
                        </h2>
                        <input
                          type="text"
                          name="Allocated"
                          class="block py-2.5 ml-5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                          placeholder=" "
                        />
                      </div>

                      <div class="flex relative z-0 w-full mb-6 group">
                        <h2 className="ml-2 mt-6 text-sm text-blue-200">
                          Location:
                        </h2>
                        <input
                          type="text"
                          name="Allocated"
                          class="block py-2.5 ml-5 px-0 w-1/2 text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                          placeholder=" "
                        />
                      </div>
                    </form>

                    <div>
                      <div
                        style={{ height: "20vh", overflow: "hidden" }}
                        className=""
                      >
                        <Map
                          defaultCenter={[21.03739, 105.7811634]}
                          defaultZoom={10}
                        >
                          {Location.map((p, i) => (
                            <Marker
                              key={i}
                              anchor={[parseFloat(p.lat), parseFloat(p.lng)]}
                              width={50}
                              color="#1F78B4"
                            />
                          ))}
                        </Map>
                      </div>
                    </div>

                    <div class="flex flex-wrap justify-center mt-8">
                      <div className="w-full flex-1 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ">
                        <div className="flex flex-wrap  mb-10 ">
                          <div className=" text-blue-200 py-4 font-medium ">
                            {" "}
                            Condition of contents:
                          </div>
                          <div className="mt-4 mr-8 ml-2 text-gray-700 font-medium">
                            Customer Name
                          </div>
                        </div>

                        <div className="flex mt-10">
                          <p className="text-blue-200 font-semibold">
                            Date of Registration
                          </p>
                        </div>
                        <div className="flex flex-wrap bg-white border-2 pl-3 pr-3 mt-1 shadow-md w-fit w-max rounded-xl">
                          <div className="flex flex-wrap float-left ">
                            <div className=" text-gray-900 py-4 font-medium ">
                              {" "}
                              <svg
                                width="22"
                                height="19"
                                viewBox="0 0 22 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20.8122 6.30951H0.90932C0.635938 6.30951 0.414062 6.1333 0.414062 5.91619V3.84382C0.414062 2.78836 1.49521 1.92975 2.82423 1.92975H18.8973C20.2261 1.92975 21.3072 2.78836 21.3072 3.84382V5.91639C21.3075 6.1335 21.0856 6.30951 20.8122 6.30951ZM1.40458 5.52288H20.317V3.84362C20.317 3.22199 19.6803 2.71618 18.8976 2.71618H2.82423C2.04123 2.71618 1.40458 3.22199 1.40458 3.84362V5.52288Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M10.3977 18.3441H2.82423C1.49521 18.3441 0.414062 17.4854 0.414062 16.43V5.91383C0.414062 5.69671 0.635938 5.52051 0.90932 5.52051H20.8122C21.0856 5.52051 21.3075 5.69671 21.3075 5.91383V9.67985C21.3075 9.89696 21.0856 10.0732 20.8122 10.0732C20.5389 10.0732 20.317 9.89696 20.317 9.67985V6.30714H1.40458V16.4298C1.40458 17.0514 2.04148 17.5572 2.82423 17.5572H10.3977C10.6711 17.5572 10.893 17.7334 10.893 17.9505C10.893 18.1677 10.6713 18.3441 10.3977 18.3441Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M4.87805 3.99841C4.60468 3.99841 4.38281 3.82221 4.38281 3.6051V1.03968C4.38281 0.822569 4.60468 0.646362 4.87805 0.646362C5.15142 0.646362 5.37329 0.822569 5.37329 1.03968V3.6051C5.37329 3.82221 5.15167 3.99841 4.87805 3.99841Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M16.839 3.99841C16.5656 3.99841 16.3438 3.82221 16.3438 3.6051V1.03968C16.3438 0.822569 16.5656 0.646362 16.839 0.646362C17.1124 0.646362 17.3342 0.822569 17.3342 1.03968V3.6051C17.3342 3.82221 17.1124 3.99841 16.839 3.99841Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M10.8624 3.99841C10.5891 3.99841 10.3672 3.82221 10.3672 3.6051V1.03968C10.3672 0.822569 10.5891 0.646362 10.8624 0.646362C11.1358 0.646362 11.3577 0.822569 11.3577 1.03968V3.6051C11.3577 3.82221 11.1358 3.99841 10.8624 3.99841Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M4.87093 8.90326H4.49479C4.32518 8.90326 4.1875 8.79411 4.1875 8.6592V8.36046C4.1875 8.22574 4.32493 8.11639 4.49479 8.11639H4.87093C5.04055 8.11639 5.17822 8.22554 5.17822 8.36046V8.6592C5.17822 8.79411 5.04079 8.90326 4.87093 8.90326Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M8.98812 8.90326H8.61198C8.44236 8.90326 8.30469 8.79411 8.30469 8.6592V8.36046C8.30469 8.22574 8.44212 8.11639 8.61198 8.11639H8.98812C9.15773 8.11639 9.29541 8.22554 9.29541 8.36046V8.6592C9.29541 8.79411 9.15798 8.90326 8.98812 8.90326Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M13.1053 8.90326H12.7292C12.5596 8.90326 12.4219 8.79411 12.4219 8.6592V8.36046C12.4219 8.22574 12.5593 8.11639 12.7292 8.11639H13.1053C13.2749 8.11639 13.4126 8.22554 13.4126 8.36046V8.6592C13.4126 8.79411 13.2752 8.90326 13.1053 8.90326Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M17.2225 8.90326H16.8464C16.6767 8.90326 16.5391 8.79411 16.5391 8.6592V8.36046C16.5391 8.22574 16.6765 8.11639 16.8464 8.11639H17.2225C17.3921 8.11639 17.5298 8.22554 17.5298 8.36046V8.6592C17.5295 8.79411 17.3921 8.90326 17.2225 8.90326Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M4.87093 12.1732H4.49479C4.32518 12.1732 4.1875 12.064 4.1875 11.9291V11.6304C4.1875 11.4957 4.32493 11.3864 4.49479 11.3864H4.87093C5.04055 11.3864 5.17822 11.4955 5.17822 11.6304V11.9291C5.17822 12.064 5.04079 12.1732 4.87093 12.1732Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M8.98812 12.1732H8.61198C8.44236 12.1732 8.30469 12.064 8.30469 11.9291V11.6304C8.30469 11.4957 8.44212 11.3864 8.61198 11.3864H8.98812C9.15773 11.3864 9.29541 11.4955 9.29541 11.6304V11.9291C9.29541 12.064 9.15798 12.1732 8.98812 12.1732Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M4.87093 15.4464H4.49479C4.32518 15.4464 4.1875 15.3373 4.1875 15.2023V14.9036C4.1875 14.7689 4.32493 14.6595 4.49479 14.6595H4.87093C5.04055 14.6595 5.17822 14.7687 5.17822 14.9036V15.2023C5.17822 15.3373 5.04079 15.4464 4.87093 15.4464Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M8.98812 15.4464H8.61198C8.44236 15.4464 8.30469 15.3373 8.30469 15.2023V14.9036C8.30469 14.7689 8.44212 14.6595 8.61198 14.6595H8.98812C9.15773 14.6595 9.29541 14.7687 9.29541 14.9036V15.2023C9.29541 15.3373 9.15798 15.4464 8.98812 15.4464Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M16.2512 18.3475C13.4633 18.3475 11.1953 16.5463 11.1953 14.3323C11.1953 12.1181 13.4633 10.3169 16.2512 10.3169C19.039 10.3169 21.307 12.1181 21.307 14.3323C21.307 16.5463 19.0387 18.3475 16.2512 18.3475ZM16.2512 11.1035C14.0094 11.1035 12.1858 12.5519 12.1858 14.3323C12.1858 16.1126 14.0094 17.5608 16.2512 17.5608C18.4929 17.5608 20.3165 16.1126 20.3165 14.3323C20.3165 12.5519 18.4927 11.1035 16.2512 11.1035Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M15.7338 15.7985C15.7298 15.7985 15.7258 15.7985 15.7219 15.7983C15.5825 15.7957 15.4507 15.7463 15.3594 15.6628L14.3084 14.6999C14.1294 14.5359 14.1517 14.2874 14.3585 14.1452C14.565 14.0032 14.8782 14.0203 15.057 14.1849L15.7514 14.8211L17.72 13.1837C17.9087 13.0262 18.2224 13.0209 18.42 13.1709C18.6179 13.321 18.6251 13.5698 18.4361 13.7269L16.0916 15.6769C15.9982 15.7546 15.869 15.7985 15.7338 15.7985Z"
                                  fill="#1F78B4"
                                />
                              </svg>
                            </div>
                            <div className="mt-3 mr-8 ml-2 text-gray-700 font-medium">
                              21-oct-2021
                            </div>
                          </div>
                          <div className="flex flex-wrap float-left ">
                            <div className=" text-gray-900 py-4 font-medium ">
                              {" "}
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                                  fill="#1F78B4"
                                />
                              </svg>
                            </div>
                            <div className="mt-3  ml-2 text-gray-700 font-medium">
                              02:45PM
                            </div>
                          </div>
                        </div>
                        <div className="flex ">
                          <p className="text-blue-200 font-semibold">
                            CheckedIn by:
                          </p>
                          <p className="text-gray-700 font-semibold">Asif</p>
                        </div>
                      </div>
                      <div className="w-full flex-1 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ml-4">
                        <div className="flex flex-wrap  mb-10 ">
                          <div className=" text-blue-200 py-4 font-medium ">
                            {" "}
                            Condition of contents:
                          </div>
                          <div className="mt-4 mr-8 ml-2 text-gray-700 font-medium">
                            Customer Name
                          </div>
                        </div>
                        <div className="flex mt-10 ">
                          <p className="text-blue-200 font-semibold">
                            Date of Modified
                          </p>
                        </div>
                        <div className="flex flex-wrap bg-white border-2 pl-3 pr-3 mt-1 shadow-md w-fit w-max rounded-xl">
                          <div className="flex flex-wrap float-right ">
                            <div className=" text-gray-900 py-4 font-medium ">
                              {" "}
                              <svg
                                width="22"
                                height="19"
                                viewBox="0 0 22 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20.8122 6.30951H0.90932C0.635938 6.30951 0.414062 6.1333 0.414062 5.91619V3.84382C0.414062 2.78836 1.49521 1.92975 2.82423 1.92975H18.8973C20.2261 1.92975 21.3072 2.78836 21.3072 3.84382V5.91639C21.3075 6.1335 21.0856 6.30951 20.8122 6.30951ZM1.40458 5.52288H20.317V3.84362C20.317 3.22199 19.6803 2.71618 18.8976 2.71618H2.82423C2.04123 2.71618 1.40458 3.22199 1.40458 3.84362V5.52288Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M10.3977 18.3441H2.82423C1.49521 18.3441 0.414062 17.4854 0.414062 16.43V5.91383C0.414062 5.69671 0.635938 5.52051 0.90932 5.52051H20.8122C21.0856 5.52051 21.3075 5.69671 21.3075 5.91383V9.67985C21.3075 9.89696 21.0856 10.0732 20.8122 10.0732C20.5389 10.0732 20.317 9.89696 20.317 9.67985V6.30714H1.40458V16.4298C1.40458 17.0514 2.04148 17.5572 2.82423 17.5572H10.3977C10.6711 17.5572 10.893 17.7334 10.893 17.9505C10.893 18.1677 10.6713 18.3441 10.3977 18.3441Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M4.87805 3.99841C4.60468 3.99841 4.38281 3.82221 4.38281 3.6051V1.03968C4.38281 0.822569 4.60468 0.646362 4.87805 0.646362C5.15142 0.646362 5.37329 0.822569 5.37329 1.03968V3.6051C5.37329 3.82221 5.15167 3.99841 4.87805 3.99841Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M16.839 3.99841C16.5656 3.99841 16.3438 3.82221 16.3438 3.6051V1.03968C16.3438 0.822569 16.5656 0.646362 16.839 0.646362C17.1124 0.646362 17.3342 0.822569 17.3342 1.03968V3.6051C17.3342 3.82221 17.1124 3.99841 16.839 3.99841Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M10.8624 3.99841C10.5891 3.99841 10.3672 3.82221 10.3672 3.6051V1.03968C10.3672 0.822569 10.5891 0.646362 10.8624 0.646362C11.1358 0.646362 11.3577 0.822569 11.3577 1.03968V3.6051C11.3577 3.82221 11.1358 3.99841 10.8624 3.99841Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M4.87093 8.90326H4.49479C4.32518 8.90326 4.1875 8.79411 4.1875 8.6592V8.36046C4.1875 8.22574 4.32493 8.11639 4.49479 8.11639H4.87093C5.04055 8.11639 5.17822 8.22554 5.17822 8.36046V8.6592C5.17822 8.79411 5.04079 8.90326 4.87093 8.90326Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M8.98812 8.90326H8.61198C8.44236 8.90326 8.30469 8.79411 8.30469 8.6592V8.36046C8.30469 8.22574 8.44212 8.11639 8.61198 8.11639H8.98812C9.15773 8.11639 9.29541 8.22554 9.29541 8.36046V8.6592C9.29541 8.79411 9.15798 8.90326 8.98812 8.90326Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M13.1053 8.90326H12.7292C12.5596 8.90326 12.4219 8.79411 12.4219 8.6592V8.36046C12.4219 8.22574 12.5593 8.11639 12.7292 8.11639H13.1053C13.2749 8.11639 13.4126 8.22554 13.4126 8.36046V8.6592C13.4126 8.79411 13.2752 8.90326 13.1053 8.90326Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M17.2225 8.90326H16.8464C16.6767 8.90326 16.5391 8.79411 16.5391 8.6592V8.36046C16.5391 8.22574 16.6765 8.11639 16.8464 8.11639H17.2225C17.3921 8.11639 17.5298 8.22554 17.5298 8.36046V8.6592C17.5295 8.79411 17.3921 8.90326 17.2225 8.90326Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M4.87093 12.1732H4.49479C4.32518 12.1732 4.1875 12.064 4.1875 11.9291V11.6304C4.1875 11.4957 4.32493 11.3864 4.49479 11.3864H4.87093C5.04055 11.3864 5.17822 11.4955 5.17822 11.6304V11.9291C5.17822 12.064 5.04079 12.1732 4.87093 12.1732Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M8.98812 12.1732H8.61198C8.44236 12.1732 8.30469 12.064 8.30469 11.9291V11.6304C8.30469 11.4957 8.44212 11.3864 8.61198 11.3864H8.98812C9.15773 11.3864 9.29541 11.4955 9.29541 11.6304V11.9291C9.29541 12.064 9.15798 12.1732 8.98812 12.1732Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M4.87093 15.4464H4.49479C4.32518 15.4464 4.1875 15.3373 4.1875 15.2023V14.9036C4.1875 14.7689 4.32493 14.6595 4.49479 14.6595H4.87093C5.04055 14.6595 5.17822 14.7687 5.17822 14.9036V15.2023C5.17822 15.3373 5.04079 15.4464 4.87093 15.4464Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M8.98812 15.4464H8.61198C8.44236 15.4464 8.30469 15.3373 8.30469 15.2023V14.9036C8.30469 14.7689 8.44212 14.6595 8.61198 14.6595H8.98812C9.15773 14.6595 9.29541 14.7687 9.29541 14.9036V15.2023C9.29541 15.3373 9.15798 15.4464 8.98812 15.4464Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M16.2512 18.3475C13.4633 18.3475 11.1953 16.5463 11.1953 14.3323C11.1953 12.1181 13.4633 10.3169 16.2512 10.3169C19.039 10.3169 21.307 12.1181 21.307 14.3323C21.307 16.5463 19.0387 18.3475 16.2512 18.3475ZM16.2512 11.1035C14.0094 11.1035 12.1858 12.5519 12.1858 14.3323C12.1858 16.1126 14.0094 17.5608 16.2512 17.5608C18.4929 17.5608 20.3165 16.1126 20.3165 14.3323C20.3165 12.5519 18.4927 11.1035 16.2512 11.1035Z"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M15.7338 15.7985C15.7298 15.7985 15.7258 15.7985 15.7219 15.7983C15.5825 15.7957 15.4507 15.7463 15.3594 15.6628L14.3084 14.6999C14.1294 14.5359 14.1517 14.2874 14.3585 14.1452C14.565 14.0032 14.8782 14.0203 15.057 14.1849L15.7514 14.8211L17.72 13.1837C17.9087 13.0262 18.2224 13.0209 18.42 13.1709C18.6179 13.321 18.6251 13.5698 18.4361 13.7269L16.0916 15.6769C15.9982 15.7546 15.869 15.7985 15.7338 15.7985Z"
                                  fill="#1F78B4"
                                />
                              </svg>
                            </div>
                            <div className="mt-3 mr-8 ml-2 text-gray-700 font-medium">
                              21-oct-2021
                            </div>
                          </div>
                          <div className="flex flex-wrap float-left ">
                            <div className=" text-gray-900 py-4 font-medium ">
                              {" "}
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                                  fill="#1F78B4"
                                />
                              </svg>
                            </div>
                            <div className="mt-3  ml-2 text-gray-700 font-medium">
                              02:45PM
                            </div>
                          </div>
                        </div>
                        <div className="flex ">
                          <p className="text-blue-200 font-semibold">
                            CheckedIn by:
                          </p>
                          <p className="text-gray-700 font-semibold">Asif</p>
                        </div>
                      </div>
                    </div>

                    {/*body*/}

                    {/*footer*/}
                    <div className="flex p-6 border-t border-solid border-slate-200 rounded-b">
                      <div className="float-left">
                        <button
                          className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                          type="button"
                          onClick={() => setShowModaldetail(false)}
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="float-right ml-auto">
                        <button
                          className="bg-green-100  text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                          type="button"
                          onClick={() => {
                            setShowModaldetail(false);
                            console.log("here modal");
                          }}
                        >
                          Pick
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
